'use client'

import { useState } from 'react'

const DOWNLOAD_URL = '/downloads/sagence-whitepaper-june-2026.pdf'

export default function WhitepaperForm() {
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organisation: '',
    newsletter_opt_in: false,
  })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitting(true)
    setError('')

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          source: 'whitepaper',
          _honey: (document.getElementById('_honey_wp') as HTMLInputElement)?.value,
        }),
      })

      if (!res.ok) {
        const data = await res.json().catch(() => null)
        throw new Error(data?.error || 'Something went wrong. Please try again.')
      }

      setSubmitted(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  if (submitted) {
    return (
      <div className="form-card" style={{ textAlign: 'center', padding: '48px 40px' }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'var(--bg-teal-tint)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--brand-primary)" strokeWidth="2.5" strokeLinecap="round" style={{ width: 28, height: 28 }}>
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2
          style={{
            fontFamily: 'var(--font-headline)',
            fontSize: 24,
            fontWeight: 400,
            letterSpacing: '-0.02em',
            color: 'var(--text-primary)',
            marginBottom: 10,
          }}
        >
          Thank you. Your download is ready.
        </h2>
        <a
          href={DOWNLOAD_URL}
          download
          className="btn-primary"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            margin: '12px 0 20px',
            background: 'var(--brand-primary)',
            padding: '13px 30px',
            fontSize: 14,
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download the whitepaper
        </a>
        <p style={{ fontSize: 14, color: 'var(--text-body)', lineHeight: 1.6 }}>
          Use the button above to download it now.
        </p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="form-card">
      {/* Honeypot */}
      <input
        type="text"
        id="_honey_wp"
        name="_honey"
        tabIndex={-1}
        autoComplete="off"
        style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
      />

      <div className="form-row">
        <label htmlFor="wp-name">First name <span style={{ color: 'var(--error)' }}>*</span></label>
        <input
          type="text"
          id="wp-name"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label htmlFor="wp-email">Email <span style={{ color: 'var(--error)' }}>*</span></label>
        <input
          type="email"
          id="wp-email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label htmlFor="wp-organisation">Organisation</label>
        <input
          type="text"
          id="wp-organisation"
          name="organisation"
          placeholder="e.g. NHS Trust name"
          value={formData.organisation}
          onChange={handleChange}
        />
      </div>

      <label className="form-checkbox">
        <input
          type="checkbox"
          name="newsletter_opt_in"
          checked={formData.newsletter_opt_in}
          onChange={handleChange}
        />
        I&apos;d like to receive occasional updates from Sagence Health
      </label>

      {error && (
        <p style={{ fontSize: 13, color: 'var(--error)', textAlign: 'center', margin: '16px 0 0' }}>{error}</p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="btn-primary"
        style={{ width: '100%', textAlign: 'center', marginTop: 24, opacity: submitting ? 0.6 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }}
      >
        {submitting ? 'Sending...' : 'Download the whitepaper'}
      </button>

      <p style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6, marginTop: 14 }}>
        Your download appears on the next screen. We won&apos;t add you to a mailing list without your permission.
      </p>
    </form>
  )
}
